const requiredValidator = value => (value || typeof value === 'number' ? undefined : 'Required');
const requiredQuillValidator = value => (value && value !== '' && value !== '<div><br></div>' ? undefined : 'Required');
const requiredOptionValidator = value => (
  value && typeof value === 'object' && 'label' in value ? undefined : 'Required'
);
const requiredObjectValidator = value => (value && value.length > 0 ? undefined : 'Required');

// eslint-disable-next-line no-useless-escape
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const urlValidator = value => (
  value && !/^(ftp|http|https):\/\/[^ "]+$/.test(value) ? 'Invalid URL - include http:// prefix' : undefined
);


const emailTagsValidator = value => (
  Array.isArray(value) && value.every(tag => emailRegex.test(tag))
    ? undefined
    : 'Added Invalid email address'
);


const minLengthArrayValidator = (value, minLength, errorText) => (
  Array.isArray(value) && value.length >= minLength
    ? undefined
    : errorText
);


const emailValidator = value => (
  value && !emailRegex.test(value)
    ? 'Invalid email address'
    : undefined
);

const charsOnlyValidator = value => (
  typeof value !== 'undefined' && value.length > 1 && !value.match(/^[A-Za-z\s]+$/)
    ? 'Use only letters'
    : undefined
);

const minLength = min => value => (
  value && value.length < min ? `Must be ${min} characters or more` : undefined
);

const maxLength = max => value => (
  value && value.length > max ? `Must be ${max} characters or less` : undefined
);

const lengthValidator = length => value => (
  value && value.length !== length ? `Must be ${length} characters long` : undefined
);

const passwordValidator = (p) => {
  const anUpperCase = /[A-Z]/;
  const aLowerCase = /[a-z]/;
  const aNumber = /[0-9]/;
  const aSpecial = /[!|@|#|$|%|^|&|*|(|)|-|_]/;
  let returnValue = null;

  if (p.length < 9) {
    returnValue = 'Must have at least 9 characters';
  }

  if (p.length > 250) {
    returnValue = 'Must have no more than 250 characters';
  }

  let numUpper = 0;
  let numLower = 0;
  let numNums = 0;
  let numSpecials = 0;
  for (let i = 0; i < p.length; i += 1) {
    if (anUpperCase.test(p[i])) {
      numUpper += 1;
    } else if (aLowerCase.test(p[i])) {
      numLower += 1;
    } else if (aNumber.test(p[i])) {
      numNums += 1;
    } else if (aSpecial.test(p[i])) {
      numSpecials += 1;
    }
  }

  if (numUpper < 1) {
    returnValue = 'Include upper case characters';
  } else if (numLower < 1) {
    returnValue = 'Include lower case characters';
  } else if (numNums < 1) {
    returnValue = 'Include at least one number';
  } else if (numSpecials < 1) {
    returnValue = 'Include at least one special character';
  }
  return returnValue;
};

const passwordsMatch = (value, allValues) =>
  (value !== allValues.password ? 'Passwords don\'t match' : undefined);

const handleBlur = (event) => {
  // in order to fix https://github.com/erikras/redux-form/issues/860
  const { relatedTarget } = event;
  if (relatedTarget && (relatedTarget.getAttribute('type') === 'button')) {
    event.preventDefault();
  }
};

export {
  requiredValidator,
  requiredQuillValidator,
  urlValidator,
  emailValidator,
  charsOnlyValidator,
  minLength,
  maxLength,
  lengthValidator,
  passwordValidator,
  passwordsMatch,
  emailRegex,
  emailTagsValidator,
  requiredOptionValidator,
  handleBlur,
  minLengthArrayValidator,
  requiredObjectValidator,
};
